import React, { FC, useEffect, useState } from 'react';
import {
	Dialog,
	DialogTitle,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import styles from './profileFormAddNewSip.module.css';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { changeSip } from '../../../service/UsersService';
import { setErrorApp, setInfoApp } from '../../../store/reducers/InfoSlice';
import { fetchProfile } from '../../../service/ProfileServiceThunk';
import { IAcc } from '../../../models/IProfile';
import { returnTasks } from '../../../service/TasksService';
import { TYPE_SERVICE } from '../../../utils/const';
import ReactDOM from 'react-dom';


interface ProfileFormAddNewSipProps {
	acc?: IAcc;
	openAddNewSip: boolean;
	handleCloseAddNewSip: (setId: any) => void;
}

const ProfileFormAddNewSip: FC<ProfileFormAddNewSipProps> = ({ openAddNewSip, handleCloseAddNewSip, acc }) => {
	const { profile } = useAppSelector((state) => state.profileReducer);

	const [loginSip, setLogin] = useState<string>("");
	const [passSip, setPass] = useState<string>("");
	const [audioCodec, setAudioCodec] = useState<string>("PCMU");
	const [serverSip, setServer] = useState<string>("multifon.ru");
	const [lineSip, setLine] = useState<number>(2);
	const [id, setId] = useState<string>("");
	const [showPassword, setShowPassword] = useState<boolean>(false);

	useEffect(() => {
		if (acc) {
			setLogin(acc.phone)
			setPass(acc.phone_pass)
			setServer(acc.server_sip)
			setLine(Number(acc.numberLines))
			setId(acc.id)
			setAudioCodec(acc.audio_codec)
		}
	}, [acc])

	const handleCloseMainDialog = () => {
		handleCloseAddNewSip(setId(""));
		setLogin("");
		setPass("");
		setServer("multifon.ru");
		setLine(2);
		setAudioCodec("PCMU");
	}

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
		event.preventDefault();
	};

	const dispatch = useAppDispatch();

	const checkTask = async (textError: string) => {
		const userTasks = await returnTasks();
		if (userTasks.error) {
			return dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Произошла ошибка при проверке запущенных задач',
				})
			);
		} else {
			const { data } = userTasks.data.data;
			if (data.length > 0) {
				for (const itemTask of data) {
					if (itemTask.nameFile.includes(TYPE_SERVICE)) {
						return dispatch(
							setErrorApp({
								isErrorApp: true,
								errorApp: textError,
							})
						);
					}
				}
			}
		}
	};

	const handleChange = (
		evt: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<any>,
		type: string
	) => {
		if (type === 'login') {
			setLogin(evt.target.value);
		} else if (type === 'password') {
			setPass(evt.target.value);
		} else if (type === 'server') {
			if (/^[0-9a-z.:]+$/gi.test(evt.target.value) || evt.target.value === '') {
				setServer(evt.target.value);
				setAudioCodec(evt.target.value.includes('mangosip') ? 'PCMA' : 'PCMU');
			}
		} else if (type === 'lines') {
			if ((/^\d+$/.test(evt.target.value) && Number(evt.target.value) <= 60) || evt.target.value === '') {
				setLine(Number(evt.target.value));
			}
		} else if (type === 'audioCodec') {
			setAudioCodec(evt.target.value);
		}
	};

	const onChangeSip = async () => {
		if (!profile) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'Профиль не найден',
				})
			);
			return;
		}
		try {
			let accs: IAcc[] = []
			if (profile.additional_accounts_getter !== undefined) {
				accs = JSON.parse(profile.additional_accounts_getter);
			}
			if (id === '') {
				accs.push({
					id: String(new Date().getTime()),
					phone: loginSip,
					phone_pass: passSip,
					server_sip: serverSip,
					numberLines: String(lineSip),
					audio_codec: audioCodec
				});
				dispatch(
					setInfoApp({
						isInfoApp: true,
						infoApp: `Дополнительный аккаунт добавлен`,
					})
				);
			} else {
				const task = await checkTask(
					'Для изменения дополнительного аккаунта, необходимо выключить прием показаний счетчиков'
				);
				if (task) return;
				for (let i = 0; i < accs.length; i++) {
					if (accs[i].id === id) {
						accs[i].phone = loginSip;
						accs[i].phone_pass = passSip;
						accs[i].server_sip = serverSip;
						accs[i].numberLines = String(lineSip);
						accs[i].audio_codec = audioCodec;
						break;
					}
				}
				dispatch(
					setInfoApp({
						isInfoApp: true,
						infoApp: `Дополнительный аккаунт изменен`,
					})
				);
			}
			await changeSip(
				{ additional_accounts_getter: JSON.stringify(accs) }
			)
			dispatch(fetchProfile());
		} catch (e) {
			dispatch(
				setErrorApp({
					isErrorApp: true,
					errorApp: 'При обновлении дополнительных аккаунтов произошла ошибка',
				})
			);
		}
		handleCloseMainDialog();
	};

	const node = document.querySelector('#modal_root');
	if (!node) return null;

	return ReactDOM.createPortal(
		<Dialog open={openAddNewSip} onClose={handleCloseMainDialog} className={styles.modal_root}>
			<DialogTitle className={styles.profile_label}>
				{id ? `Изменить дополнительный аккаунт` : `Добавить дополнительный аккаунт`}
				<button onClick={handleCloseMainDialog} className={styles.close_modal}>
					×
				</button>
			</DialogTitle>
			<div className={styles.wrapper_for_sip_options}>
				<DialogContent className={styles.dialog_content}>
					<DialogContentText className={styles.label_for_wrapper_sip}>
						SIP аккаунт
					</DialogContentText>
					<TextField
						margin="dense"
						id="login_sip"
						label="Логин sip"
						fullWidth
						variant="standard"
						value={loginSip}
						onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
							handleChange(evt, 'login')
						}
					/>
					<TextField
						margin="dense"
						id="outlined-adornment-password-sip"
						fullWidth
						variant="standard"
						className={styles.password_input}
						type={showPassword ? 'text' : 'password'}
						value={passSip}
						onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
							handleChange(evt, 'password')
						}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										aria-label="toggle password visibility"
										onClick={handleClickShowPassword}
										onMouseDown={handleMouseDownPassword}
										edge="end"
									>
										{showPassword ? <VisibilityOff /> : <Visibility />}
									</IconButton>
								</InputAdornment>
							),
						}}
						label="Пароль sip"
					/>
					<TextField
						margin="dense"
						id="server_sip"
						label="Адрес sip сервера"
						fullWidth
						variant="standard"
						value={serverSip}
						onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
							handleChange(evt, 'server')
						}
					/>
					<TextField
						inputProps={{ inputMode: 'numeric', min: 1, max: 60 }}
						margin="dense"
						id="line_sip"
						label="Количество линий"
						fullWidth
						variant="standard"
						value={lineSip}
						onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
							handleChange(evt, 'lines')
						}
					/>
					<FormControl variant="standard" sx={{ m: '8px 0px', minWidth: 540 }}>
						<InputLabel id="demo-simple-select-standard-label">Выбор аудио кодека</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							value={audioCodec}
							onChange={(evt: SelectChangeEvent<any>) =>
								handleChange(evt, 'audioCodec')}
						>
							<MenuItem value={'PCMA'}>G.711 a (PCMA)</MenuItem>
							<MenuItem value={'PCMU'}>G.711 u (PCMU)</MenuItem>
						</Select>
					</FormControl>
				</DialogContent>
				<DialogActions className={styles.wrapper_for_buttons}>
					<Button
						disabled={
							loginSip.length === 0 ||
							(!loginSip.trim()) ||
							passSip.length === 0 ||
							(!passSip.trim()) ||
							serverSip.length === 0 ||
							(!serverSip.trim()) ||
							Number(lineSip) > 60 ||
							Number(lineSip) < 1
						}
						onClick={onChangeSip}
					>
						Сохранить
					</Button>
				</DialogActions>
			</div>
		</Dialog>,
		node
	);
};

export default ProfileFormAddNewSip;
